import { render, staticRenderFns } from "./RespostaCardCotacaoDetalhesProdutos.vue?vue&type=template&id=4cbcaa3b"
import script from "./RespostaCardCotacaoDetalhesProdutos.vue?vue&type=script&lang=js"
export * from "./RespostaCardCotacaoDetalhesProdutos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports